import { useEffect, useState, FormEvent, ChangeEvent } from "react";
import Modal from "../../tailadmin/components/ui/Modal";
import { useAuth } from "../../context/AuthContext";
import { toast } from "react-toastify";
import Button from "../ui/Button";
import { usePrescription } from "../../context/PrescriptionContext";
import workoutplans from "../../services/workoutplans";
import FichaItem from "./FichaItem";
import BottomModal from "../ui/BottomModal";
import InputDefault from "../ui/InputDefault";
import utils from "../../helpers/utils";
import { WorkoutPlan, Prescription, ExerciseInPlan } from "../../types";

interface WorkoutModalProps {
  isOpen: boolean;
  onBack: () => void;
  data: Partial<WorkoutPlan> | null;
  user_id?: number | null;
}

function WorkoutModal({
  isOpen,
  onBack,
  data,
  user_id = null,
}: WorkoutModalProps) {
  const { getUser } = useAuth();
  const {
    INIT_WORK,
    userModal,
    setFichaId,
    addFicha,
    submitWorkout,
    removeFichaId,
  } = usePrescription();
  const [form, setForm] = useState<
    Partial<WorkoutPlan> & { user_id?: number; professional?: number }
  >({
    ...INIT_WORK,
    user_id: userModal?.id,
    professional: getUser()?.id,
  });

  useEffect(() => {
    if (isOpen) {
      setForm(
        data ?? {
          ...INIT_WORK,
          user_id: userModal?.id,
          professional: getUser()?.id,
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const deleteWorkout = async () => {
    if (!form?.id) return;
    const rep = await workoutplans.delete_plan(String(form.id));
    if (rep) {
      toast.success("Plano de Treino removido com sucesso!");
      onBack();
    }
  };

  const submit = async (e?: FormEvent) => {
    e?.preventDefault();
    await submitWorkout(form);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onBack()}
      title="Plano de Treino"
      className="!w-full !max-w-full sm:!max-w-[900px]"
    >
      <div className="">
        <form onSubmit={submit} className="grid w-full p-2 sm:p-4">
          <div className="flex w-full">
            <div className="container">
              <div className="w-full h-full">
                <div className="mb-8 w-full mt-4">
                  <InputDefault
                    label="Nome do Plano Treino"
                    id="plan_name"
                    name="plan_name"
                    type="text"
                    value={form.name || form.plan_name || ""}
                    required={true}
                    onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
                      setForm({ ...form, [target.name]: target.value });
                    }}
                  />

                  <InputDefault
                    label="Objetivo"
                    id="objective"
                    name="objective"
                    type="text"
                    value={form.objective || ""}
                    required={true}
                    onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
                      setForm({ ...form, [target.name]: target.value });
                    }}
                    placeholder="Ganho de massa magra..."
                  />

                  <div className="flex flex-col sm:flex-row justify-between gap-4">
                    <InputDefault
                      label="Início"
                      id="start_date"
                      name="start_date"
                      type="date"
                      value={form.start_date}
                      required={true}
                      onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
                        setForm({ ...form, [target.name]: target.value });
                      }}
                      placeholder="Ganho de massa magra..."
                    />

                    <InputDefault
                      label="Fim"
                      id="end_date"
                      name="end_date"
                      type="date"
                      value={form.end_date}
                      required={true}
                      onChange={({ target }: ChangeEvent<HTMLInputElement>) => {
                        setForm({ ...form, [target.name]: target.value });
                      }}
                    />
                  </div>
                  <div className="mt-6">
                    <h4 className="font-bold italic text-xl text-black dark:text-white">
                      Fichas:
                    </h4>

                    <div className="justify-between gap-3 grid grid-cols-1 sm:grid-cols-2 mt-2 p-1">
                      {data?.prescriptions?.map((c: Prescription) => (
                        <FichaItem
                          key={c.id}
                          data={c}
                          iconVariant={true}
                          onDelete={(a: Prescription | ExerciseInPlan) =>
                            removeFichaId(String((a as Prescription).id))
                          }
                          onClick={(a: Prescription | ExerciseInPlan) =>
                            setFichaId(String((a as Prescription).id))
                          }
                        />
                      ))}
                      <Button
                        title=""
                        className="w-1/4"
                        onClick={() => addFicha(utils.generateId())}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div className="pb-2 p-4 pt-2">
          <BottomModal
            type="submit"
            onBack={onBack}
            id={form?.id}
            onDelete={deleteWorkout}
            onSave={submit}
          />
        </div>
      </div>
    </Modal>
  );
}

export default WorkoutModal;
